import styled from 'styled-components';

export const Content = styled.div`
  color: var(--color-title);

  a {
    text-decoration: underline;
    :hover {
      text-decoration: none;
    }
  }

  .subtitle {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: var(--color-brand);
    margin: 0;
    padding: 0 0 30px;

    b {
      font-weight: 600;
    }
  }

  .scrollContainer {
    overflow-x: auto;
    height: max-content;
    padding: 0 0 5px;

    table {
      min-width: 100%;
      width: max-content;

      @media (min-width: 768px) {
        max-width: none;
        color: inherit;

        thead {
          background: transparent;

          &::after {
            display: none;
          }

          tr {
            height: auto;
            font-size: inherit;
            text-transform: none;
            color: inherit;
          }
        }

        td,
        th,
        td > *,
        th > * {
          white-space: normal;
          overflow: visible;
        }
      }

      tr {
        border-bottom: 1px solid var(--color-border);
        &:last-child {
          border-bottom: none;
        }
        td:first-child,
        th:first-child {
          text-align: left;
          color: var(--color-title);
          padding-left: 0;
          font-size: 14px;
          line-height: 20px;
          max-width: 270px;
        }
        th:first-child {
          font-weight: 400;
          vertical-align: bottom;
        }
        td:first-child {
          font-weight: 500;
        }
        td:last-child,
        th:last-child {
          padding-right: 0;
        }
        td,
        th {
          padding: 10px 8px;
          text-align: center;

          svg {
            display: inline-block;
          }
        }
        td.in-person-channels {
          font-weight: 400;
          font-size: 12px;
          line-height: 16px;
        }
        th {
          .name {
            font-weight: 600;
            font-size: 18px;
            line-height: 27px;
            padding: 0 0 8px;
          }
          .price {
            gap: 6px;
            font-weight: 600;
            font-size: 40px;
            line-height: 40px;
            padding: 0 0 8px;
            span {
              font-weight: 500;
              font-size: 14px;
              line-height: 22px;
            }
          }
        }
      }
    }
  }

  .fair-use {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--color-text-muted);
  }

  .divider {
    margin: 30px 0 30px;
  }

  .more-info {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding: 0 0 10px;

    b {
      font-weight: 600;
    }
  }

  .our-fair-usage-policy {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;

    b {
      font-weight: 600;
    }
  }

  .button-container {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    padding: 40px 0 0;

    .right {
      display: flex;
      gap: 10px;
    }
    button {
      width: max-content;
    }
    .green-button {
      color: var(--color-surface);
      border: 1px solid #8ebd84;
      background: #8ebd84;
      outline: none;
      :hover {
        border: 1px solid #81b177;
        background: #81b177;
        outline: none;
      }
    }
  }
`;
